import React, { useState } from 'react';
import Form from './components/form';
import FormReset from './components/form-reset';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { grey, yellow, orange, blue } from '@mui/material/colors';
import logo from './utils/logo.svg'
import PhoneInTalkRoundedIcon from "@mui/icons-material/PhoneInTalkRounded";
import AlternateEmailRoundedIcon from "@mui/icons-material/AlternateEmailRounded";
import './App.css';

const App = () => {
  const [showForm, setView] = useState("true");

  const handleMainContent = (show:any) => {
    setView(show);
  };

  const formStatus = () => { return showForm }

  const theme = createTheme({ 
    palette: { 
        primary: { 
            main: grey[900], 
        }, 
        secondary: { 
            main: yellow[200], 
        }, 
        success: { 
            main: grey[500], 
        }, 
        warning: { 
            main: yellow[700], 
        }, 
        info: { 
            main: orange[500], 
        }, 
        error: { 
            main: blue[100], 
        }, 
    }, 
  }); 
  
  return (
      <ThemeProvider theme={theme}>
        <main>
          <img className="sei-logo" src={logo}/>
          <a className='icon-link' href='tel:+17163793376'><PhoneInTalkRoundedIcon fontSize='small'/>&nbsp;<span>(716)-379-3376</span></a>
          <a className='icon-link' href="mailto:dan@standardissueelectric.com"><AlternateEmailRoundedIcon fontSize='small'/>&nbsp;<span>dan@standardissueelectric.com</span></a>
          <ul>
            <li>new contruction</li>
            <li>remodel/repair</li>
            <li>outlet/switch install</li>
            <li>light fixture install</li>
            <li>panel service</li>
            <li>fuse replacement</li>
            <li>circuit breakers</li>
            <li>generators</li>
            <li>...and more!</li>
          </ul>
        <footer>&copy;2024 Standard Issue Electric</footer>
        </main>
        <section>
        <h3 className='section-header'>With over a decade of experience, we
             are excited to serve the Cattaraugus/Allegany area
             for all your electrical needs.
             We look forward to hearing from you at
             Standard Issue Electric
             ...where our standard is <i>excellence!</i></h3>
             { showForm == 'true'? <Form updateValue={handleMainContent}/> : <FormReset updateValue={handleMainContent}/> }    
        </section>
      </ThemeProvider>
    );
}

export default App;
